import React from 'react';
import Seo from '../components/Seo';
import styled from 'styled-components';
import { Section, Container } from '../shared/ui';

const Title = styled.h1`
  font-size: 2.2rem;
  font-weight: 800;
  color: var(--brand);
  margin-bottom: 1.5rem;
`;
const Heading = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--brand);
  margin: 2rem 0 0.75rem 0;
`;
const Text = styled.p`
  color: #3a4662;
  line-height: 1.7;
  margin: 0 0 0.75rem 0;
`;
const Content = styled.div`
  max-width: 760px;
  margin: 0 auto;
`;

const Impressum: React.FC = () => (
  <>
    <Seo
      title="Impressum | AP Clean Services"
      description="Impressum und Anbieterkennzeichnung der AP Clean Services, Gütersloh."
      path="/impressum"
    />
    <Section>
      <Container>
        <Content>
          <Title>Impressum</Title>

          <Heading>Angaben gemäß § 5 DDG</Heading>
          <Text>
            AP Clean Services<br />
            Inhaber: Abimanju Premachandran<br />
            Moltkestr. 20<br />
            33330 Gütersloh<br />
            Deutschland
          </Text>

          <Heading>Kontakt</Heading>
          <Text>
            Telefon: <a href="tel:+491729182451">+49 172 9182451</a><br />
            E-Mail: <a href="mailto:info@apcleanservices.de">info@apcleanservices.de</a>
          </Text>

          <Heading>Umsatzsteuer-Identifikationsnummer</Heading>
          <Text>
            Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
            DE457367373
          </Text>

          <Heading>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</Heading>
          <Text>
            Abimanju Premachandran<br />
            Moltkestr. 20<br />
            33330 Gütersloh
          </Text>

          <Heading>Verbraucherstreitbeilegung / Universalschlichtungsstelle</Heading>
          <Text>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </Text>

          <Heading>Haftung für Inhalte</Heading>
          <Text>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach
            den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter
            jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
            oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </Text>

          <Heading>Haftung für Links</Heading>
          <Text>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
            Seiten verantwortlich.
          </Text>

          <Heading>Urheberrecht</Heading>
          <Text>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
            deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Downloads und Kopien
            dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
          </Text>
        </Content>
      </Container>
    </Section>
  </>
);

export default Impressum;
